<template>
  <div class="card card-info">
    <div class="card-header">
      <h3 class="card-title">Student Card Printing</h3>
    </div>
    <!-- /.card-header -->
    <!-- form start -->
    <div class="card-body">
      <div class="row">
        <div class="col-md-4">
          <label>Session *</label>
          <select class="form-control" v-model="filter.SessionID">
            <option value="0">--Select Session--</option>
            <option v-for="item in sessions" v-bind:value="item.SessionID">{{item.Name}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Program</label>

          <select class="form-control" v-model="filter.ProgramID">
            <option value="0">--Select Program--</option>
            <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Gender</label>
          <select class="form-control" v-model="filter.Gender">
            <option value="">--Select Gender--</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Disability</label>
          <select class="form-control" v-model="filter.Disabilty">
            <option value="">--Select--</option>
            <option value="True">Yes</option>
            <option value="False">No</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Resident Of LOC</label>
          <select class="form-control" v-model="filter.ResidentOfLOC">
            <option value="">--Select--</option>
            <option value="True">Yes</option>
            <option value="False">No</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Verified</label>
          <select class="form-control" v-model="filter.Verified">
            <option value="">--Select--</option>
            <option value="True">Yes</option>
            <option value="False">No</option>
          </select>
        </div>
        <div class="col-md-4">
          <label>Name</label>
          <input class="form-control" v-model="filter.Name" />
        </div>
        <div class="col-md-4">
          <label>City</label>

          <input class="form-control" v-model="filter.City" />
        </div>
        <div class="col-md-4">
          <label>District</label>

          <input class="form-control" v-model="filter.District" />
        </div>
        <div class="col-md-4">
          <label>Tehsil</label>

          <input class="form-control" v-model="filter.Tehsil" />
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label>Date From </label>
            <input v-model="filter.DateFrom" type="date" class="form-control" required />
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label>Date To </label>
            <input v-model="filter.DateTo" type="date" class="form-control" required />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group float-right">
            <button class="btn btn-primary" type="button" style="margin-top: 20px;" v-on:click="btnSearch()">Search</button>
            <button class="btn btn-primary" type="button" style="margin-top: 20px;" v-on:click="exportexcel()" v-if="exceldatastatus==='enabled'">Export All Data</button>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 10px" v-if="prospects.length > 0">
        <div class="col-md-12">
          <hr />
          <div class="table-responsive">
            <table id="bs4-table" class="table table-striped table-sm" style="font-size: 12px;">
              <thead class="bg-info">
                <tr>
                  <th style="width: 5px; text-align: center">Sr.#</th>
                  <th style="width: 10%">Entry Date</th>
                  <th style="width: 10%">Session</th>
                  <th style="width: 10%">Program</th>
                  <th style="width: 10%">Name</th>
                  <th style="width: 10%">Father Name</th>
                  <th style="width: 10%">CNIC</th>
                  <th style="width: 10%">DoB</th>
                  <th style="width: 15%">District</th>
                  <th style="width: 15%">Verified</th>
                  <th style="width: 25px; text-align: center;">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(p, ind) in prospects">
                  <td style="text-align: center; vertical-align: middle">{{ind + 1}}</td>
                  <td style="vertical-align: middle">{{p.InsertedOn}}</td>
                  <td style="vertical-align: middle">{{p.Session}}</td>
                  <td style="vertical-align: middle">{{p.ProgramName}}</td>
                  <td style="vertical-align: middle">{{p.Name}}</td>
                  <td style="vertical-align: middle">{{p.FatherName}}</td>
                  <td style="vertical-align: middle">{{p.CNIC}}</td>
                  <td style="vertical-align: middle">{{p.DateOfBirth}}</td>
                  <td style="vertical-align: middle">{{p.District}}</td>
                  <td style="vertical-align: middle"><span v-if="p.Verified">Verified</span><span v-else>Un-Verified</span></td>
                  <td style="vertical-align: middle; text-align: center;">
                    <div class="btn-group-vertical">
                      <button type="button" class="btn btn-warning" data-toggle="tooltip" title="Edit" v-on:click="edit(p.StudentID)"><i class="fa fa-pen"></i></button>
                      <button type="button" class="btn btn-info" data-toggle="tooltip" title="Print Card" v-if="p.Verified" v-on:click="PrintFront(p.StudentID)"><i class="fa fa-id-card"></i></button>
                      <!--<button type="button" class="btn btn-primary" data-toggle="tooltip" title="Card Back" v-if="p.Verified" v-on:click="PrintBack(p.StudentID)"><i class="fa fa-id-card-alt"></i></button>-->
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        departments: [],
        programs: [],
        selDegreeID: 0,
        sessions: [],
        degrees: [],
        filter: { ProgramID: 0, City: '', Gender: '', Name: '', District: '', SessionID: 0, Disabilty: '', ResidentOfLOC: '', Verified: '', Tehsil: '' },
        prospects: [],
        Types: 1,
        exceldata: [],
        exceldatastatus: 'default',
        delete: { id: '', ind: '' },
        showImage: false,
        category: [],
        depID: 0,
      }
    },

    created: function () {
    },

    mounted: function () {
      this.pageLoad();
    },

    updated: function () {
      if (this.prospects.length != 0) {
        $('#bs4-table').DataTable();
      }
    },

    methods: {
      pageLoad: function () {
        startReq();
        var vm = this;
        axios.post('/api/StudentCardPrintingApi/pageLoadStudentIndex')
          .then(function (res) {
            endReq();
            vm.programs = res.data.programs;
            vm.sessions = res.data.sessions;
          })
      },

      btnSearch() {
        //if (this.filter.SessionID == 0 || this.filter.SessionID == '') {
        //  toastr.error("Session Is Required");
        //}
        startReq();
        var vm = this;
        axios.post('/api/StudentCardPrintingApi/StudentCardIndexPageLoad', {
          filter: vm.filter,
        })
          .then(function (res) {
            var table = $('#bs4-table').DataTable();
            table.destroy();
            vm.prospects = res.data;
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },

      edit(ID) {
        startReq();
        var vm = this;
        axios.post('/api/StudentCardPrintingApi/EditCard?ID=' + ID)
          .then(function (res) {
            endReq();
            window.location.href = "/StudentCardPrint/Edit";
          })
          .catch(function (error) {
            console.log(error);
          })
      },

      //PrintFront(ID) {
      //  startReq();
      //  var vm = this;
      //  axios.post('/api/StudentCardPrintingApi/PrintFront?ID=' + ID)
      //    .then(function (res) {
      //      endReq();
      //      window.open("/StudentCardPrint/PrintCardFront", '_blank');
      //    })
      //},

      PrintFront(ID) {
        startReq();
        var vm = this;
        axios.post('/api/StudentCardPrintingApi/PrintFront?ID=' + ID)
          .then(function (res) {
            endReq();
            window.open("/StudentCardPrint/PrintCardFrontBack", '_blank');
          })
      },

      //PrintBack(ID) {
      //  startReq();
      //  var vm = this;
      //  axios.post('/api/StudentCardPrintingApi/PrintBack?ID=' + ID)
      //    .then(function (res) {
      //      endReq();
      //      window.open("/StudentCardPrint/PrintCardBack", '_blank');
      //    })
      //},
    }
  })</script>

<style>
  table thead tr th {
    background-color: #605ca8;
    color: white;
  }

  blink {
    -webkit-animation: 2s linear infinite condemned_blink_effect;
  }

  @-webkit-keyframes condemned_blink_effect {

    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }

  @keyframes condemned_blink_effect {
    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/cardprinting/studentCardPrintingIndex.vue